export class FlinkDeploymentObservation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "crPresent",
            "baseName": "crPresent",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "lifecycleState",
            "baseName": "lifecycleState",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobManagerDeploymentStatus",
            "baseName": "jobManagerDeploymentStatus",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobState",
            "baseName": "jobState",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastError",
            "baseName": "lastError",
            "type": "string",
            "format": ""
        },
        {
            "name": "reconciliationState",
            "baseName": "reconciliationState",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FlinkDeploymentObservation.attributeTypeMap;
    }
    constructor() {
    }
}
